import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = async function (dom, name, isDownLoad = true) {
      let title = name || 'index'
      return new Promise((res) => {
        // html2Canvas(dom, {
        //   allowTaint: true,
        //   taintTest: false,
        //   useCORS: true,
        //   dpi: window.devicePixelRatio * 2, //将分辨率提高到特定的DPI 提高
        //   scale: 2 //按比例增加分辨率
        // }).then(function (canvas) {
        //   let contentWidth = canvas.width
        //   let contentHeight = canvas.height
        //   let pageHeight = contentWidth / 592.28 * 841.89
        //   let leftHeight = contentHeight
        //   let position = 0
        //   let imgWidth = 595.28
        //   let imgHeight = 592.28 / contentWidth * contentHeight
        //   let pageData = canvas.toDataURL('image/jpeg', 1.0)
        //   let PDF = new JsPDF('', 'pt', 'a4')
        //   if (leftHeight < pageHeight) {
        //     PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        //   } else {
        //     while (leftHeight > 0) {
        //       PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        //       leftHeight -= pageHeight
        //       position -= 841.89
        //       if (leftHeight > 0) {
        //         PDF.addPage()
        //       }
        //     }
        //   }
        //   if (isDownLoad) {
        //     PDF.save(title + '.pdf')
        //     res(true);
        //   } else {
        //     res(dataURLtoFile(PDF.output('datauristring'), title + '.pdf'));
        //   }
        // })
        
        let PDF = new JsPDF()
        PDF.html(dom, {
          callback(pdf) {
            if (isDownLoad) {
              pdf.save(title + '.pdf')
              res(true);
            } else {
              res(dataURLtoFile(pdf.output('datauristring'), title + '.pdf'));
            }
          },
          windowWidth: 1240,
          width: 210
        });
      })
    }
  },
}